(() => {
  const more = document.getElementById('ksMore');
  more?.addEventListener('click', (event) => {
    event.preventDefault();
    document.querySelectorAll('.ks-card.ks-hide').forEach((card) => card.classList.remove('ks-hide'));
    more.hidden = true;
  });

  const starts = Date.now();
  const duration = ((8 * 60 + 57) * 60 + 27) * 1000;
  const updateClock = () => {
    const seconds = Math.max(0, Math.ceil((duration - (Date.now() - starts)) / 1000));
    const hours = String(Math.floor(seconds / 3600)).padStart(2, '0');
    const minutes = String(Math.floor((seconds % 3600) / 60)).padStart(2, '0');
    const remainder = String(seconds % 60).padStart(2, '0');
    document.querySelectorAll('.cdh').forEach((item) => { item.textContent = hours; });
    document.querySelectorAll('.cdm').forEach((item) => { item.textContent = minutes; });
    document.querySelectorAll('.cds').forEach((item) => { item.textContent = remainder; });
  };
  updateClock();
  setInterval(updateClock, 1000);

  document.querySelectorAll('a.js-cta').forEach((link) => {
    link.addEventListener('click', () => {
      const params = new URLSearchParams(window.location.search);
      const target = new URL(link.href);
      target.search = params.toString();
      link.href = target.toString();
    });
  });
})();
